<template>
  <div class="form-outline">
    <!-- file input for CAMERA AND GALLERY -->
    <form-legend :field="field" />
    <div class="d-flex items-center">
      <v-file-input
        v-if="!readonly && mx_attachmentMode === attachmentModeOptions.cameraAndGallery"
        class="camera-file-input"
        prepend-icon="mdi-camera"
        hide-input
        hide-details
        :value="imagePreviews"
        multiple
        capture="user"
        accept="image/*"
        :rules="field.required ? [() => imagePreviews.length > 0 || $t('field.required')] : []"
        persistent-hint
        @change="(images) => addImagePreview(images)"
        v-bind="darkOrLightMode"
        color="primary-action"
      />
      <!-- file input for CAMERA ONLY when there is no selection/ gallery input -->
      <v-file-input
        v-if="!readonly && mx_attachmentMode === attachmentModeOptions.cameraOnly"
        prepend-icon="mdi-camera"
        :value="imagePreviews"
        multiple
        capture="user"
        accept="image/*"
        :rules="field.required ? [() => imagePreviews.length > 0 || $t('field.required')] : []"
        :hint="hint"
        persistent-hint
        @change="(images) => addImagePreview(images)"
        color="primary-action"
        outlined
        clearable
        style="flex-grow: 30"
      >
        <template v-slot:label>
          <form-legend :field="field" class="pt-1" />
        </template>
        <template v-slot:message="{ message }">
          <legend v-html="translateIfExist(message)" />
        </template>
      </v-file-input>
      <!-- file input for selection -->
      <v-file-input
        v-if="!readonly && (mx_attachmentMode === attachmentModeOptions.cameraAndGallery || mx_attachmentMode === attachmentModeOptions.galleryOnly)"
        :prepend-icon="mx_attachmentMode === attachmentModeOptions.galleryOnly ? 'mdi-paperclip' : 'mdi-image'"
        :value="imagePreviews"
        multiple
        accept="image/*"
        :rules="field.required ? [() => imagePreviews.length > 0 || $t('field.required')] : []"
        :hint="hint"
        persistent-hint
        @change="(images) => addImagePreview(images)"
        v-bind="darkOrLightMode"
        outlined
        clearable
        color="primary-action"
        style="flex-grow: 30"
      >
        <template v-slot:label>
          <form-legend :field="field" class="pt-1" />
        </template>
        <template v-slot:message="{ message }">
          <legend v-html="translateIfExist(message)" />
        </template>
      </v-file-input>
    </div>
    <v-img v-for="(img, index) in imagePreviews" :key="'img-' + index" :src="img.base64File" contain class="img-preview">
      <v-overlay v-if="!readonly" absolute color="#9E9E9E" class="img-overlay">
        <v-icon class="preview-delete-icon" @click="removeImg(index)"> mdi-close</v-icon>
      </v-overlay>
    </v-img>
  </div>
</template>

<script>
import { preprocessImage } from '@/common/mediaUtils';
import configMixin from '@/mixins/configMixin';
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';
import config from '@/common/config';
import common from '@/mixins/common';

export default {
  components: { FormLegend },
  mixins: [formsMixin, configMixin, common],
  emits: ['formUpdated'],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      galleryCameraSwitchEnabled: true, // for the time being this is a local flag, to enable the user to switch between camera and gallery. Might be configurable in future by tenant / usage
    };
  },
  computed: {
    /**
     * @returns {Array} Array of image previews
     */
    imagePreviews() {
      return this.mediasModel.filter((i) => i.field === this.field.cid);
    },
    moduleConfig() {
      return this.getModuleConfig(this.$route.meta.moduleType, this.$route.params.instance);
    },
    hint() {
      return this.field.field_options.description;
    },
  },
  methods: {
    formUpdated() {
      this.$emit('formUpdated', this.field.cid, this.mediasModel);
    },
    async addImagePreview(images) {
      //TODO: Refactor to display one snackbar item only - or may be we do not display the snackbar
      images
        .filter((i) => i.type && !i.type.startsWith('image/'))
        .forEach((i) => this.$store.commit('snackbar/displaySnackbar', { text: this.$t('forms.imagesOnly') }));

      // Value must be set to imagePreviews to ensure validation update but this
      // triggers addImagePreview as well so we need to filter here
      let filteredImages = images.filter((i) => !!i.name && i.type && i.type.startsWith('image/'));

      for (const image of filteredImages) {
        console.debug(filteredImages);
        const base64Image = await preprocessImage(image);

        this.mediasModel.push({
          field: this.field.cid,
          base64File: base64Image,
        });
      }
      this.formUpdated();
    },
    removeImg(index) {
      this.mediasModel.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.img-preview {
  width: 200px;
  height: 150px;
  margin: 4px;
  display: inline-block;
}

.preview-delete-icon {
  font-size: 20px !important;
}

.preview-delete-icon:hover {
  cursor: pointer;
}

.img-overlay {
  left: auto;
  width: 20px;
  height: 20px;
}

.camera-file-input {
  margin-right: -5px;
  margin-top: 3px;
}
</style>
